// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationPropertiesStateConfigResponseDto } from './IOrganizationPropertiesStateConfigResponseDto';
import {
    IOrganizationPropertiesStateConfigResponseDtoFromJSON,
    IOrganizationPropertiesStateConfigResponseDtoFromJSONTyped,
    IOrganizationPropertiesStateConfigResponseDtoToJSON,
    IOrganizationPropertiesStateConfigResponseDtoToJSONTyped,
} from './IOrganizationPropertiesStateConfigResponseDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageOrganizationPropertiesStateConfigResponseDto
 */
export interface IPageOrganizationPropertiesStateConfigResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IOrganizationPropertiesStateConfigResponseDto>}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    content?: Array<IOrganizationPropertiesStateConfigResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageOrganizationPropertiesStateConfigResponseDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageOrganizationPropertiesStateConfigResponseDto interface.
 */
export function instanceOfIPageOrganizationPropertiesStateConfigResponseDto(value: object): value is IPageOrganizationPropertiesStateConfigResponseDto {
    return true;
}

export function IPageOrganizationPropertiesStateConfigResponseDtoFromJSON(json: any): IPageOrganizationPropertiesStateConfigResponseDto {
    return IPageOrganizationPropertiesStateConfigResponseDtoFromJSONTyped(json, false);
}

export function IPageOrganizationPropertiesStateConfigResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageOrganizationPropertiesStateConfigResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IOrganizationPropertiesStateConfigResponseDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageOrganizationPropertiesStateConfigResponseDtoToJSON(json: any): IPageOrganizationPropertiesStateConfigResponseDto {
    return IPageOrganizationPropertiesStateConfigResponseDtoToJSONTyped(json, false);
}

export function IPageOrganizationPropertiesStateConfigResponseDtoToJSONTyped(value?: IPageOrganizationPropertiesStateConfigResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IOrganizationPropertiesStateConfigResponseDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

